/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { Checkbox as AntdCheckbox } from "antd";
import { CheckerActionType } from "src/constants/theme.constant";
import { CheckboxProps as AntdCheckboxProps } from "antd";
import { CheckboxGroupProps as AntdCheckboxGroupProps } from "antd/es/checkbox";

type CheckboxProps = AntdCheckboxProps & AntdCheckboxGroupProps & {
  className?: string,
  typeCheckbox: CheckerActionType,
  isCheckAllControl?: boolean,
};

const Checkbox = ({
  typeCheckbox,
  className,
  isCheckAllControl,
  ...props
}: CheckboxProps) => {
  return (
    <>
      {typeCheckbox === CheckerActionType.Button ? (
        <AntdCheckbox
          {...props}
          className={`checkbox-primary ${className ?? ''}`}
          indeterminate={isCheckAllControl} />
      ) : (
        <AntdCheckbox.Group
          {...props}
          className={`checkbox-group-primary ${className ?? ''}`}
        />
      )}
    </>
  );
};

export default Checkbox;
